import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { get, post } from '../../ApiServices/ApiServices';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Container from '../../Container/Container';
import { toast, ToastContainer } from 'react-toastify';
import Loader from '../Component/Loader';
import InputMask from "react-input-mask";

const AddCustomer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state || {};

    const [isLoading, setIsLoading] = useState(false);
    const [userid, setuserid] = useState(null);
    const [selectedOption, setSelectedOption] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState(false);
    const [AltRedio, setAltRedio] = useState(false);
    const [store, setStore] = useState("");
    const [getState, setGetState] = useState([]);
    const [isFormLoading, setisFormLoading] = useState(false);

    // State for autocomplete
    const [autocomplete, setAutocomplete] = useState(null);
    const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
    const [isAddressManuallyEdited, setIsAddressManuallyEdited] = useState(false);

    // Google Maps API Key - Replace with your actual key
    const GOOGLE_MAPS_API_KEY = 'AIzaSyB5WrOGc_JpDhLbKfHO_CnzRircdez4GLA';

    // US States mapping for converting state codes to full names

    const US_STATES_MAP = {
        'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
        'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
        'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
        'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
        'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
        'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
        'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
        'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
        'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
        'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
        'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
        'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
        'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia'
    };

    // Load Google Maps Script
    const loadGoogleMapsScript = () => {
        if (window.google && window.google.maps) {
            setIsGoogleMapsLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => setIsGoogleMapsLoaded(true);
        document.head.appendChild(script);
    };

    // Initialize Google Maps Script on mount
    useEffect(() => {
        loadGoogleMapsScript();
    }, []);

    // Initialize autocomplete when Google Maps is loaded and form is ready
    useEffect(() => {
        if (!isGoogleMapsLoaded || !window.google || isLoading) {
            return;
        }

        // Find the address input element
        const addressInput = document.getElementById('address-input');
        if (!addressInput) {
            return;
        }

        // Only initialize if not already initialized
        if (autocomplete) {
            return;
        }

        // Initialize autocomplete
        const newAutocomplete = new window.google.maps.places.Autocomplete(
            addressInput,
            {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
        );

        // Add place changed listener
        newAutocomplete.addListener('place_changed', () => {
            handlePlaceSelect(newAutocomplete);
        });

        setAutocomplete(newAutocomplete);

        // Cleanup function
        return () => {
            if (window.google && window.google.maps && window.google.maps.event) {
                window.google.maps.event.clearInstanceListeners(addressInput);
            }
        };
    }, [isGoogleMapsLoaded, isLoading]);

    // Handle place selection from autocomplete
    const handlePlaceSelect = async (autocompleteInstance) => {
        const place = autocompleteInstance.getPlace();

        if (!place.geometry) {
            toast.error('No details available for this address');
            return;
        }

        // Extract address components
        let streetNumber = '';
        let route = '';
        let city = '';
        let stateCode = '';
        let stateName = '';
        let zipCode = '';

        place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                stateCode = component.short_name;
                stateName = component.long_name;
            } else if (types.includes('postal_code')) {
                zipCode = component.long_name;
            }
        });

        const fullAddress = streetNumber && route ? `${streetNumber} ${route}` : place.name;
        const fullStateName = US_STATES_MAP[stateCode] || stateName;

        setIsAddressManuallyEdited(false);

        // Use setFieldValue for each field individually to preserve other form values
        formik.setFieldValue('address', fullAddress, false);
        formik.setFieldValue('city', city, false);
        formik.setFieldValue('state', fullStateName, false);
        formik.setFieldValue('zip', zipCode, false);

        // Mark fields as touched
        formik.setFieldTouched('address', true, false);
        formik.setFieldTouched('city', true, false);
        formik.setFieldTouched('state', true, false);
        formik.setFieldTouched('zip', true, false);

        await formik.validateForm();
    };

    // Handle manual address input change
    const handleAddressChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue('address', value);
        setIsAddressManuallyEdited(true);

        // Only clear dependent fields if address is completely cleared
        if (!value.trim()) {
            formik.setFieldValue('city', '');
            formik.setFieldValue('state', '');
            formik.setFieldValue('zip', '');
        }
    };

    // Reset manual edit flag when other fields are manually edited
    const handleCityChange = (e) => {
        formik.handleChange(e);
        setIsAddressManuallyEdited(true);
    };

    const handleStateChange = (e) => {
        formik.handleChange(e);
        setIsAddressManuallyEdited(true);
    };

    const handleZipChange = (e) => {
        formik.handleChange(e);
        setIsAddressManuallyEdited(true);
    };

    const handleCheckboxChange = () => {
        const newValue = !formik.values.isAltPickupEnable;
        formik.setFieldValue('isAltPickupEnable', newValue);
    };

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        if (phoneNumber.length < 4) return phoneNumber;
        if (phoneNumber.length < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    };

    const normalizeInput = (value) => {
        if (!value) return value;
        return value.replace(/[^\d]/g, '');
    };

    const handlePhoneChange = (e) => {
        const { value } = e.target;
        const normalized = normalizeInput(value);
        const formatted = formatPhoneNumber(normalized);
        formik.setFieldValue('phone', formatted);
    };

    const initialValues = {
        companyName: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        account: '',
        address: '',
        addressLine2: "",
        state: '',
        city: '',
        zip: '',
        isDropShipEnable: false,
        isAltPickupEnable: false,
        isUpdate: !!id,
        isEmailEnable: false
    };

    const validationSchema = Yup.object().shape({
        companyName: Yup.string().required('Company name is required'),
        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
        phone: Yup.string()
            .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Phone number must be in format (XXX) XXX-XXXX')
            .required('Phone number is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        ...(id ? {} : {
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
        }),
        account: Yup.string()
            .required('Account is required')
            .max(2, 'Account must be exactly 2 characters')
            .min(2, 'Account must be exactly 2 characters')
            .matches(
                /^[a-zA-Z0-9]{2}$/,
                'Account must be exactly 2 letters or numbers (no spaces/symbols)'
            )
            .trim()
            .strict(true),
        address: Yup.string().required('Address is required'),
        state: Yup.string().required('State is required'),
        city: Yup.string().required('City is required'),
        zip: Yup.string()
            .required('ZIP code is required')
            .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid zip code format'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                setisFormLoading(true);
                const endpoint = id ? `edit-customer/${id}` : "create-customer";
                const { isUpdate, confirmPassword, ...submitData } = values;
                const payload = id ? submitData : values;

                const response = await post(endpoint, payload);

                if (response.status) {
                    setuserid(response?.data?.id);
                    toast.success(response?.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        closeButton: false,
                    });
                    navigate('/customers');
                }
            } catch (err) {
                toast.error(err?.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
            }
            finally {
                setisFormLoading(false);
            }
        },
    });

    const handleToggleChange = (e) => {
        formik.setFieldValue('isEmailEnable', e.target.checked);
    };

    const FormvalidationSchemas = Yup.object({
        affiliatedStore: Yup.string().required("Affiliated store is required."),
    });

    const formHandler = useFormik({
        initialValues: {
            affiliatedStore: "",
        },
        validationSchema: FormvalidationSchemas,
        onSubmit: async (values) => {
            const endpoint = selectedOption == "Drop Shipping" ? `add-customer-shipping-address/${userid || id}` : `add-customer-affiliated-store/${userid || id}`;
            const response = await post(endpoint, values);
            toast.success(response?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            navigate('/customers');
        },
    });

    const ViewState = async () => {
        try {
            const api = `get-states`;
            const response = await get(api);
            if (response?.message == "success") {
                setGetState(response.data);
            }
        } catch (err) {
            console.error('Error:', err);
        }
    };

    useEffect(() => {
        ViewState();
    }, []);

    useEffect(() => {
        const fetchCustomerData = async () => {
            if (id) {
                try {
                    setIsLoading(true);
                    const response = await get(`view-customer/${id}`);
                    setStore(response?.data?.affiliatedStore);
                    if (response?.data) {
                        const customerData = response.data;
                        formik.setValues({
                            companyName: customerData?.companyName || '',
                            firstName: customerData?.firstName || '',
                            lastName: customerData?.lastName || '',
                            phone: customerData?.phone || '',
                            email: customerData?.email || '',
                            account: customerData?.account || '',
                            address: customerData?.addresses?.[0]?.billingAddress || '',
                            addressLine2: customerData?.addresses?.[0]?.billingAddressLine2 || '',
                            state: customerData?.addresses?.[0]?.billingState || '',
                            city: customerData?.addresses?.[0]?.billingCity || '',
                            zip: customerData?.addresses?.[0]?.billingZip || '',
                            isDropShipEnable: customerData?.isDropShipEnable || false,
                            isAltPickupEnable: customerData?.isAltPickupEnable || false,
                            isUpdate: true,
                            isEmailEnable: customerData?.isEmailEnable || false
                        });

                        if (formik.values.isAltPickupEnable) {
                            setAltRedio(true);
                        }

                        if (customerData?.affiliatedStore == null) {
                            setSelectedOption("Drop Shipping");
                        }
                    }
                } catch (err) {
                    console.error('Error fetching customer data:', err);
                } finally {
                    setIsLoading(false);
                }
            }
        };
        fetchCustomerData();
    }, [id]);

    useEffect(() => {
        if (formik.values.isAltPickupEnable) {
            setAltRedio(true);
        } else {
            setAltRedio(false);
            formik.setFieldValue('affiliatedStore', "");
        }
    }, [formik.values.isAltPickupEnable]);

    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{id ? 'Update' : 'Add'} Wholesale Stores</h3>
                                    </div>
                                    <div className="">
                                        <span
                                            onClick={() => navigate(-1)}
                                            className="btn btn-outline-light"
                                        >
                                            <em class="icon ni ni-arrow-left"></em> <span> Back</span>
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div class="card card-full inputCardBox">
                                <div class="card-inner">
                                    <div class="card-title-group mb-3">
                                        <div class="card-title"><h6 class="title">Personal Info</h6></div>
                                    </div>

                                    {isLoading ? (
                                        <div className="flex justify-center items-center py-8"><Loader /></div>
                                    ) : (
                                        <>
                                            <form onSubmit={formik.handleSubmit}>
                                                <div class="row">
                                                    <div class="col-md-4 mb-3">
                                                        <label>Company Name <span className="text-red-500">*</span></label>
                                                        <input class="" type="text"
                                                            placeholder="Enter company name"
                                                            {...formik.getFieldProps('companyName')} />
                                                        {formik.touched.companyName && formik.errors.companyName && (
                                                            <div className="error">{formik.errors.companyName}</div>
                                                        )}
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <label>First Name <span className="text-red-500">*</span></label>
                                                        <input class="" type="text"
                                                            placeholder="Enter first name"
                                                            {...formik.getFieldProps('firstName')} />
                                                        {formik.touched.firstName && formik.errors.firstName && (
                                                            <div className="error">{formik.errors.firstName}</div>
                                                        )}
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <label>Last Name <span className="text-red-500">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter last name"
                                                            {...formik.getFieldProps('lastName')}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.lastName && formik.errors.lastName && (
                                                            <div className="error">{formik.errors.lastName}</div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="block text-sm font-medium text-gray-700">
                                                            Phone Number <span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            placeholder="(XXX) XXX-XXXX"
                                                            name="phone"
                                                            value={formik.values.phone}
                                                            onChange={handlePhoneChange}
                                                            onBlur={formik.handleBlur}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.phone && formik.errors.phone && (
                                                            <div className="text-red-500 text-sm mt-1">{formik.errors.phone}</div>
                                                        )}
                                                    </div>

                                                    <div class="col-md-4 mb-3">
                                                        <label>Email Address <span className="text-red-500">*</span></label>
                                                        <input
                                                            type="email"
                                                            placeholder="Enter email"
                                                            {...formik.getFieldProps('email')}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.email && formik.errors.email && (
                                                            <div className="error">{formik.errors.email}</div>
                                                        )}
                                                    </div>

                                                    <div class="col-md-4 mb-3">
                                                        <label>Acct # <span className="text-red-500">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter account"
                                                            {...formik.getFieldProps('account')}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.account && formik.errors.account && (
                                                            <div className="error">{formik.errors.account}</div>
                                                        )}
                                                    </div>
                                                    {!id && (
                                                        <>
                                                            <div class="col-md-4 mb-3">
                                                                <label>Password <span className="text-red-500">*</span></label>
                                                                <input
                                                                    type="password"
                                                                    placeholder="Enter password"
                                                                    {...formik.getFieldProps('password')}
                                                                    className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                                />
                                                                {formik.touched.password && formik.errors.password && (
                                                                    <div className="error">{formik.errors.password}</div>
                                                                )}
                                                            </div>
                                                            <div class="col-md-4 mb-3">
                                                                <label>Confirm Password <span className="text-red-500">*</span></label>
                                                                <input
                                                                    type="password"
                                                                    placeholder="Enter confirm password"
                                                                    {...formik.getFieldProps('confirmPassword')}
                                                                    className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                                />
                                                                {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                                                                    <div className="error">{formik.errors.confirmPassword}</div>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                <div class="card-title-group mb-3 mt-3"><div class="card-title"><h6 class="title">Billing Address</h6></div></div>
                                                <div class="row">
                                                    <div class="col-md-4 mb-3">
                                                        <label>Address <span className="text-red-500">*</span></label>
                                                        <input
                                                            id="address-input"
                                                            type="text"
                                                            placeholder="Start typing address..."
                                                            name="address"
                                                            value={formik.values.address}
                                                            onChange={handleAddressChange}
                                                            onBlur={formik.handleBlur}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.address && formik.errors.address && (
                                                            <div className="error">{formik.errors.address}</div>
                                                        )}
                                                        <div className="text-xs text-gray-500 mt-1">
                                                            Start typing to see address suggestions
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <label>Address 2 (Optional)</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter address 2"
                                                            {...formik.getFieldProps('addressLine2')}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <label>City <span className="text-red-500">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter city"
                                                            name="city"
                                                            value={formik.values.city}
                                                            onChange={handleCityChange}
                                                            onBlur={formik.handleBlur}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.city && formik.errors.city && (
                                                            <div className="error">{formik.errors.city}</div>
                                                        )}
                                                    </div>
                                                    <div class="col-md-4 mb-3 form-control-select">
                                                        <label>State <span className="text-red-500">*</span></label>
                                                        <select
                                                            name="state"
                                                            value={formik.values.state}
                                                            onChange={handleStateChange}
                                                            onBlur={formik.handleBlur}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        >
                                                            <option value="">Select state</option>
                                                            {getState.length > 0 && getState.map((items, index) => (
                                                                <option key={index} value={items.name}>{items.name}</option>
                                                            ))}
                                                        </select>
                                                        {formik.touched.state && formik.errors.state && (
                                                            <div className="error">{formik.errors.state}</div>
                                                        )}
                                                    </div>

                                                    <div class="col-md-4 mb-3">
                                                        <label>Zip Code <span className="text-red-500">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter zip code"
                                                            name="zip"
                                                            value={formik.values.zip}
                                                            onChange={handleZipChange}
                                                            onBlur={formik.handleBlur}
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        />
                                                        {formik.touched.zip && formik.errors.zip && (
                                                            <div className="error">{formik.errors.zip}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="custom-control custom-control-sm custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customSwitch9"
                                                            checked={formik.values.isEmailEnable}
                                                            onChange={handleToggleChange}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customSwitch9">
                                                            Receive Email Alert
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="custom-control custom-control-sm custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customSwitch7"
                                                            checked={formik.values.isDropShipEnable}
                                                            onChange={() => formik.setFieldValue('isDropShipEnable', !formik.values.isDropShipEnable)}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customSwitch7">
                                                            Drop Shipping
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mb-2">
                                                    <div className="custom-control custom-control-sm custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customSwitch8"
                                                            checked={formik.values.isAltPickupEnable}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="custom-control-label" htmlFor="customSwitch8">
                                                            Alternate Pickup Location
                                                        </label>
                                                    </div>
                                                </div>



                                                {formik.values.isAltPickupEnable &&
                                                    <div className="col-md-4 mt-3">
                                                        <label>Affiliated Store</label>
                                                        <select
                                                            name="affiliatedStore"
                                                            value={formik.values.affiliatedStore}
                                                            onChange={formik.handleChange}
                                                            disabled
                                                            className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                        >
                                                            <option value=""> {store ? store : "Not assigned"}</option>
                                                            <option value="Roberts Menswear">Roberts Menswear</option>
                                                            <option value="Fashion House">Fashion House</option>
                                                            <option value="Trend Setter">Trend Setter</option>
                                                            <option value="Style Central">Style Central</option>
                                                            <option value="Chic Boutique">Chic Boutique</option>
                                                        </select>
                                                        {formik.errors.affiliatedStore && formik.touched.affiliatedStore && (
                                                            <div className="text-red-500">{formik.errors.affiliatedStore}</div>
                                                        )}
                                                    </div>
                                                }

                                                <div class="row">
                                                    <div class="col-md-12 mt-3">
                                                        <button
                                                            type="submit"
                                                            style={isFormLoading ? { pointerEvents: "none" } : {}}
                                                            disabled={isFormLoading}
                                                            className="addBtnCustomer"
                                                        >
                                                            {isFormLoading ? (
                                                                <>
                                                                    <span className="spinner"></span> {id ? 'Save' : 'Add'}
                                                                </>
                                                            ) : (
                                                                id ? 'Save' : 'Add'
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default AddCustomer;